import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { CINCHCARE_ELIGIBLE_DAYS_AFTER_DELIVERY, SERVICE_AND_WARRANTY_ELIGIBLE_DAYS_AFTER_ORDER } from "../constants";
dayjs.extend(utc);
export var checkCinchCareEligibility = function(vehicleOrder, allCinchCareOrders) {
    var isServiceAndWarrantyEnabled = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var ref;
    var deliverySlotDate = (ref = vehicleOrder.deliverySlot) === null || ref === void 0 ? void 0 : ref.date;
    var deliveryDate = deliverySlotDate ? dayjs.utc(deliverySlotDate) : null;
    var over100DaysAgo = dayjs.utc().subtract(isServiceAndWarrantyEnabled ? SERVICE_AND_WARRANTY_ELIGIBLE_DAYS_AFTER_ORDER : CINCHCARE_ELIGIBLE_DAYS_AFTER_DELIVERY, "days").subtract(1, "days") // this ensures exactly 100 days ago is allowed
    ;
    var alreadyHasCinchCare = allCinchCareOrders === null || allCinchCareOrders === void 0 ? void 0 : allCinchCareOrders.map(function(plan) {
        return plan.vehicleVrm;
    }).includes(vehicleOrder.vehicle.vrm);
    if (!deliveryDate || alreadyHasCinchCare) {
        return false;
    }
    return orderIsCompleted(vehicleOrder.orderStatus) && deliveryDate.isAfter(over100DaysAgo, "seconds");
};
var orderIsCompleted = function(orderStatus) {
    return orderStatus === "OrderCompleted" || orderStatus === "Fulfilled";
};
